import { Component } from '@angular/core';

@Component({
  selector: 'app-no-favorites',
  standalone: true,
  imports: [],
  templateUrl: './no-favorites.component.html',
  styleUrl: './no-favorites.component.scss'
})
export class NoFavoritesComponent {}
